<template>
    <teleport to="#modal">
        <ConfermaModal
            v-if="confirmDelete"
            :backdrop="false"
            :visible="confirmDelete"
            @reject="confirmDelete = false"
            @confirm="performDelete"
        >
        </ConfermaModal>
    </teleport>

    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton component="router-link" :to="{name: 'NuovoCliente'}" variant="primary"
                                class="w-44 ml-3 text-sm py-2 px-4 m-0">
                        + Aggiungi
                    </NextButton>
                </div>
            </div>
            <h3 class="text-3xl font-bold">{{ ETabTitle[filterState] || ETabTitle[0] }}</h3>
            <HomeAlertBar
                :ok="alert_counters.ok"
                :scaduti="alert_counters.scaduti"
                :in_scadenza="alert_counters.in_scadenza"
                :contatti="alert_counters.contatti"
                :clienti="alert_counters.clienti"
                :active="filterState"
            ></HomeAlertBar>
            <!--      <Grid :cols="cols" :rows="rows"></Grid>-->
            <NextTable class="w-full table-fixed border-separate border-spacing-3 py-4" :cols="cols" :rows="lista.rows"
                       @order-update="lista.updateCols">
                <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_0`]="{context}">
                    <TableTooltip :inner_class="context.cell.td_class">{{
                            context.row[context.cell.prop]
                        }}
                    </TableTooltip>
                </template>
                <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_1`]="{context}">
                    <TableTooltip :inner_class="context.cell.td_class">{{
                            context.row[context.cell.prop]
                        }}
                    </TableTooltip>
                </template>
                <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                    <router-link :to="{name:'DettaglioAzienda', params:{id:context.context.row.id}}"
                                 class="block text-center inset-0 absolute flex items-center justify-center"><i
                        class="icon-chevron_destra"></i></router-link>
                </template>
                <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                    <TabellaContextMenu
                        menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                        buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                        :context="c"
                        :id="j"
                        teleport_to="#modal"
                        :cmOpener="cmOpener"
                    >
                        <router-link :to="{name:'Attivita', params: {id:c.id}}" class="hover:text-next-neu mb-2">
                            Attività
                        </router-link>
                        <router-link :to="{name:'Contatti', params: {id:c.id}}" class="hover:text-next-neu mb-2">
                            Contatti
                        </router-link>
                        <span @click="cancellaAzienda(c.id)" class="text-next-orange">Elimina</span>
                    </TabellaContextMenu>
                </template>
                <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                    {{ $filters.toDate(context.context.row.created_at) }}
                </template>
                <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_2`]="{context}">
                    <div class="grid gap-1"
                         :style="{'grid-template-columns': `repeat(${businessUnits.length}, minmax(0, 1fr))`}">
                        <div v-for="bu in businessUnits" class="" :key="bu.id">
                            <div class="border border-next-neu rounded text-center text-xs">
                                {{ bu.label }}
                            </div>
                            <div :class="`bg-next-${getColoriStati(context.row.stati[bu.id])}`"
                                 class="border rounded text-center text-xs text-white">
                                {{ getLabel(context.row.stati[bu.id]) }}
                            </div>
                        </div>
                    </div>
                </template>
            </NextTable>
            <InfiniteLoading @infinite="lista.fetchNextPage" :identifier="lista.infiniteIdentifier"
                             style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri clienti.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import Topbar from "../components/Topbar.vue";
import NextTable from "@/components/NextTable.vue";
import meManager from "../api/Me";
import {AlertState, ColoriStati, LabelStati, Paths, TabTitle} from "@/types";
import Paginator from "@/components/Paginator.vue";
import HomeAlertBar from "@/components/HomeAlertBar.vue";
import {alert_in_scadenza, alert_scaduti, clienti_da_richiamare} from "@/BreadcrumbsPath";
import businessUnitsManager from "../api/BusinessUnits";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenu from "@/components/ContextMenu.vue";
import ConfermaModal from "@/components/ConfermaModal.vue";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import TableTooltip from "@/components/TableTooltip.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Lista from "@/setup/ListaCerca";

@Options({
    name: 'HomeFiltered',
    components: {
        NextButton,
        HomeAlertBar,
        Breadcrumbs,
        Topbar,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ContextMenu,
        ConfermaModal,
        TabellaContextMenu,
        TableTooltip
    },
    props: {
        filterState: Number
    }
})
export default class HomeFiltered extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    ETabTitle = TabTitle
    cm_visible = -1
    confirmDelete = false
    deleteId = 0
    lista: any = setup(() => Lista(clientiManager, this.cols));

    cancellaAzienda(id: number) {
        this.confirmDelete = true;
        this.deleteId = id;
    }

    performDelete() {
        clientiManager.delete(this.deleteId).then(() => {
            this.lista.reset()
        }).finally(() => {
            this.confirmDelete = false
        })
    }

    filterState!: number;
    businessUnits: never[] = []

    alert_counters = {
        ok: 0,
        clienti: 0,
        in_scadenza: 0,
        scaduti: 0,
        contatti: 0
    }


    sort = ''

    user = {
        name: '',
    }

    @Watch('filterState')
    reload() {
        this.lista.apiParams['stato'] = this.filterState;
        this.lista.reset()
    }

    get getBreadcrumbsPath(): Paths[] {
        switch (this.filterState) {
            case AlertState.PENDENTE:
                return clienti_da_richiamare
            case AlertState.SCADUTO:
                return alert_scaduti
            case AlertState.IN_SCADENZA:
                return alert_in_scadenza
        }
        return []
    }

    getColoriStati(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return ColoriStati[ColoriStati.neu]
        }
        return ColoriStati[EnumStato]
    }

    getLabel(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return LabelStati[LabelStati.NEU]
        }
        return LabelStati[EnumStato]
    }

    created(): void {
        businessUnitsManager.businessUnits({params:{crm: 1}}).then((response) => {
            this.businessUnits = response.data
        })
        this.reload()
        meManager.me().then((response) => {
            this.user = response.data
        })
        meManager.counters().then((response) => {
            this.alert_counters = {...this.alert_counters, ...response.data}

        });
    }

    cols = [
        {
            name: 'Denominazione',
            prop: 'denominazione',
            orderable: true,
            class: 'text-left min-w-350',
            td_class: 'w-full overflow-visible relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Settore commerciale',
            prop: 'settori_join',
            orderable: false,
            class: 'text-left min-w-350',
            td_class: 'w-full overflow-visible relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'denominazione',
            orderable: false,
            class: 'text-left min-w-next-stato w-next-stato whitespace-nowrap',
            td_class: 'bg-transparent',
            resizable: false
        },
        {
            name: 'Ultimo contatto',
            prop: 'created_at',
            orderable: true,
            class: 'text-left min-w-150 w-150 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        }
    ]
}


</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
